/*
 *  Campaign__Chart.jsx
 */

//==============================================================================
// External dep.
//==============================================================================
import React from "react";
import logger from "../../utils/LoggerFrontend";

const { ResponsiveContainer, Area, AreaChart, Tooltip } = require("recharts");

//==============================================================================
// Module
//==============================================================================
//const CustomTooltip  = React.createClass({

class CampaignChart extends React.Component {
  render() {
    const { active } = this.props;

    if (active) {
      const { payload } = this.props;
      logger.debug("CampaignChart:render", "called...", this.props);
      return (
        <div className="custom-tooltip">
          <p className="custom-tooltip__nr">{payload[0].payload.name}</p>
          <p className="custom-tooltip__label">Impressions: {payload[0].payload.impressions}</p>
          <p className="custom-tooltip__label">Clicks: {payload[0].value}</p>
        </div>
      );
    }
    return null;
  }
}

export default class CampaignReadChart extends React.Component {
  render() {
    logger.debug("CampaignReadChart:render:then", "called...", this.props.data);

    return (
      <div className="chart">
        <div className="chart__col">
          <ResponsiveContainer>
            <AreaChart width={100} height={100} data={this.props.data}>
              <Tooltip />
              <Area
                type="monotone"
                dataKey="unique_clicks"
                stackId="1"
                stroke="#a4e7ff"
                fill="#d9f5ff"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}
